import { Link } from 'react-router-dom'

import serviceHome from '../../api/serviceHome'
import Shape from '../../images/right-arrow-2.svg'

const ServiceHomeSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(0, 0)
  }

  return (
    <section className={'' + props.hclass}>
      <div className="container-fluid p-0">
        {/* <div className=""> */}
        <h2 className="service-title fade_bottom">Our Services</h2>
        {/* </div> */}

        {/* <div className="service-top">
          <div className="image">
            <img src={Topimage} alt="service-bg" />
          </div>
          <div className="content">
            <h2 className="fade_bottom">Our Service</h2>
            <p className="fade_bottom">
              At Apex company, we offer a full spectrum of services
             .{' '}
            </p>
          </div>
        </div> */}
        <div className="container">
          <div className="service-wrap">
          {serviceHome.slice(0, 8).map((service, index) => (
            <div className="service-card" key={index}>
              <div className="card-content">
                <img src={service.Icon} alt={service.title} />
                <h2>{service.title}</h2>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
        
          {/* <div className="row">
            {Services.slice(0, 8).map((service, item) => (
              <div className="col-lg-2 col-md-3 col-12 fade_bottom" key={item}>
                <div className="service-card-home">
                  <div className="icon">
                    <img className='icon-service' src={service.Icon} alt="icon" />
                  </div>
                  <h2>
                    <Link
                      onClick={ClickHandler}
                      to={`/service-single/${service.slug}`}
                    >
                    {service.title}
                    </Link>
                  </h2>
                  <p>{service.description}</p>
                </div>
              </div>
            ))}
          </div> */}
        </div>
       
      </div>
       <div className="project-allBtn fade_bottom">
          <Link onClick={ClickHandler} to="/services" className="theme-btn">
            <span>All Services</span>
            <img src={Shape} alt="" />
          </Link>
        </div>
    </section>
  )
}

export default ServiceHomeSection
